import React from "react";

import Link from "../Link";

import {
  Container,
  CardImage,
  CardInfoContainer,
  CardTitle,
  CardDescription,
  AdditionalMessage,
} from "./styles";

function TabCard({ imageSrc, iconComponent, title, description, height, soon, link }) {
  const IconComponent = iconComponent;
  return (
    <Container height={height}>
      <CardImage>
        {IconComponent && <IconComponent />}
        {imageSrc && <img src={imageSrc} alt="card_image" />}
      </CardImage>
      <CardInfoContainer>
        {link ? (
          <Link to={link}>
            <CardTitle>
              {title}
              {soon && (
                <AdditionalMessage>
                  <span>SOON</span>
                </AdditionalMessage>
              )}
            </CardTitle>
            <CardDescription>{description}</CardDescription>
          </Link>
        ) : (
          <>
            <CardTitle>
              {title}
              {soon && (
                <AdditionalMessage>
                  <span>soon</span>
                </AdditionalMessage>
              )}
            </CardTitle>
            <CardDescription>{description}</CardDescription>
          </>
        )}
      </CardInfoContainer>
    </Container>
  );
}

export default TabCard;
